// Shared bank-number format patterns. A US bank routing number is always 9 digits; an
// account number runs 5–17 digits. Used by both Pool and CustodialAccount validation so the
// two can't drift.
export const NINE_DIGITS = /^\d{9}$/;
export const FIVE_TO_SEVENTEEN_DIGITS = /^\d{5,17}$/;
